module.exports = __webpack_public_path__ + "img/content-hzzw.2a3399e9.png";